import React from "react";
import { List } from "./List";

export const RemainsList = () => {
  return <List articles={["12121212", "121212132", "121421212"]}></List>;
};
